import {Injectable} from '@angular/core';
@Injectable()
export class IndexPluginsService {
  requirePlugins () {
    setTimeout(() => {
      require('assets/js/bootstrap.min.js');
      require('assets/js/plugins/metisMenu/jquery.metisMenu.js');
      require('assets/js/plugins/slimscroll/jquery.slimscroll.min.js');
      require('assets/js/inspinia.js');
      // require('assets/js/plugins/pace/pace.js');
      require('assets/js/plugins/sweetalert/sweetalert.min.js');
    }, 1000);
  }
}



// WEBPACK FOOTER //
// D:/taile-operate/BLACK-WIDOW/ng-src/app/services/index/index-plugins.service.ts